// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"vQ yc","ribbon":"vR ym","title":"vS ye","seasons":"vT yk","genres":"vU yl","buttonWrapper":"vV yh","button":"vW yi"};